import styled from 'styled-components'

import Location from './Location'

const Table = styled.div`
  display: table;
  padding: 1em;
`
const TableRow = styled.div`
  display: table-row;
`
const TableCell = styled.div`
  display: table-cell;
  text-align: left;
`
const BlueSpan = styled.span`
  color: blue;
`


export default function FullResults({ coordinates, mapUnits, location, queryData, onLessClick }) {
  //console.log(queryData);
  const noParcel = !queryData ? true : (
    !queryData.hasOwnProperty('attributes') ? true : (
      queryData.attributes.hasOwnProperty('rightlow') ? true : false
    )
  )
  return (
    <>
      <Location
        coordinates={coordinates}
        mapUnits={mapUnits}
      />
      <div>
      {noParcel ? (
        <div style={{textAlign: 'center'}}>
          <br/>
          Nothing Found.
        </div>
      ) : (
        <Table>
          {!queryData ? null : (
            Object.keys(queryData.attributes).map((key) => {
              return (
                <TableRow key={key}>
                  <TableCell>
                    {key}:
                  </TableCell>
                  <div style={{display: 'table-cell', minWidth: '1em'}} />
                  <TableCell>
                  {queryData.attributes[key]}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </Table>
      )}
      </div>
      <br/>
      <div style={{textAlign: 'center'}}>
      <BlueSpan onClick={onLessClick}>-less-</BlueSpan>
      </div>
    </>
  );
}
